export default function random(noDate = false) {
  return noDate
    ? ""
    : Date.now().toString() +
        "_" +
        (Math.random().toString(36).substring(2, 10) +
          Math.random().toString(36).substring(2, 10));
}
